import { split } from 'lodash'

class AgentAgreement {
  id
  code
  dateBegin
  dateEnd
  aproc
  aname
  comments
  curators

  getCode () {
    return this.code
  }

  static assign (json) {
    const agreement = Object.assign(new AgentAgreement(), json)
    // leave curatorEmails untouched - for saving purposes
    agreement.curators = split(json.curatorEmails, /[;, ]/).filter(s => s !== '')
    agreement.code && (agreement.code = ('' + agreement.code).trim())
    agreement.aname && (agreement.aname = ('' + agreement.aname).trim())
    return agreement
  }
}

export default AgentAgreement



// WEBPACK FOOTER //
// ./src/models/dictionaries/agentAgreement.js